<script>
export default {
  name: 'RestoreConfirmModal',

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  emits: ['confirm', 'cancel'],

  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => this.$refs.dialog.showModal());
      } else {
        this.$refs.dialog.close();
      }
    }
  }
}
</script>
<template>
  <dialog ref="dialog" class="modal">
    <div class="modal-box">
      <h3 class="text-lg font-bold">Restore configuration?</h3>
      <p class="py-4">
        This will overwrite the device's current configuration with the selected file.
        This cannot be undone.
      </p>
      <div class="modal-action">
        <form method="dialog">
          <button class="btn btn-ghost mr-2" @click="$emit('cancel')">Cancel</button>
          <button class="btn btn-primary" @click="$emit('confirm')">Restore</button>
        </form>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button @click="$emit('cancel')">close</button>
    </form>
  </dialog>
</template>
